/**
 * Code for MSH Notification Listing Module
 */
import $ from "jquery";

InitNotificationListingViewMore();
ConvertNotificationDateTime();

function InitNotificationListingViewMore() {
    $("#notification-viewmore").on("click", function () {
        NotificationListingViewMore();
    });
}

function NotificationListingViewMore() {
    var currentPageSizeBeforePost = $("#notification-currentpagesize").val();
    $.ajax({
        url: '/notifications/listingviewmore',
        data: {
            adID: $("#notification-adid").val(),
            currentPageSize: $("#notification-currentpagesize").val(),
            allNotificationsCount: $("#notification-allnotificationscount").val(),
            newNotificationsCount: $("#notification-newnotificationscount").val(),
        },
        success: function (resp) {
            if (resp) {
                if (resp.Success) {
                    $('#notification-listing-container').html(resp.Data.Html);
                    $('#notification-listing-container').foundation();
                    InitNotificationListingViewMore();
                    ConvertNotificationDateTime();
                    NextElementFocus(currentPageSizeBeforePost);
                }
            }
        }
    })
}
function ConvertNotificationDateTime() {
    $("#notification-listing-container .notification-block_date").each(function () {
        var date = new Date($(this).text());
        var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
        $(this).text($.datepicker.formatDate('MM dd, yy', newDate))
    });
}

function NextElementFocus(currentPageSizeBeforePost) {
    var counterMaxLoop = 8; // Default View More Page Size
    var counter = 1;
    // Find if the items has a link and set it to focus
    while (counter <= counterMaxLoop) {
        var nextItemFocusIndex = parseInt(currentPageSizeBeforePost) + counter;
        var nextElementToFocus = $('#notification-listing-container').find(".notification-item-" + nextItemFocusIndex + " a").first();
        if (nextElementToFocus.length) {
            nextElementToFocus.focus();
            break;
        }
        counter++;
    }
}